import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    // ContractCode yeşil (logo rengi - analiz ile uyumlu)
    primary: {
      main: '#22c55e',      // Green-500 (ContractCode ana yeşil)
      light: '#4ade80',     // Green-400
      dark: '#16a34a',      // Green-600 (hover states)
      contrastText: '#ffffff',
    },
    // Nötr gri-mavi (secondary)
    secondary: {
      main: '#64748b',      // Slate-500
      light: '#94a3b8',     // Slate-400
      dark: '#334155',      // Slate-700
      contrastText: '#ffffff',
    },
    error: {
      main: '#ef4444',      // Red-500
    },
    warning: {
      main: '#f59e0b',      // Amber-500
    },
    success: {
      main: '#22c55e',      // Green-500 (same as primary)
    },
    background: {
      default: '#f9fafb',   // Gray-50
      paper: '#ffffff',
    },
    text: {
      primary: '#111827',   // Gray-900
      secondary: '#6b7280', // Gray-500
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Don't uppercase button text
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;

